<script setup lang="ts">
import AirConditionerLargeIcon from "#/ui-kit/assets/icons/program-appliance-category/air-conditioner-large.svg?component";
import AirConditionerSmallIcon from "#/ui-kit/assets/icons/program-appliance-category/air-conditioner-small.svg?component";
import HeaterLargeIcon from "#/ui-kit/assets/icons/program-appliance-category/heater-large.svg?component";
import HeaterSmallIcon from "#/ui-kit/assets/icons/program-appliance-category/heater-small.svg?component";
import HeatPumpLargeIcon from "#/ui-kit/assets/icons/program-appliance-category/heatpump-large.svg?component";
import OtherLargeIcon from "#/ui-kit/assets/icons/program-appliance-category/other-large.svg?component";
import OtherSmallIcon from "#/ui-kit/assets/icons/program-appliance-category/other-small.svg?component";
import WaterHeaterLargeIcon from "#/ui-kit/assets/icons/program-appliance-category/water-heater-large.svg?component";
import WaterHeaterSmallIcon from "#/ui-kit/assets/icons/program-appliance-category/water-heater-small.svg?component";

interface IProps {
  sectionApplianceCategory: string;
  size?: "small" | "large";
}

const PROGRAM_APPLIANCE_CATEGORY = {
  AC_UNIT_NON_INFRARED: "AC_UNIT_NON_INFRARED",
  HEATER: "HEATER",
  HEAT_PUMP: "HEAT_PUMP",
  WATER_HEATER: "WATER_HEATER",
} as const;

const props = withDefaults(defineProps<IProps>(), {
  size: "small",
});
</script>

<template>
  <div v-if="props.size === 'small'">
    <HeaterSmallIcon v-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.HEATER" />
    <WaterHeaterSmallIcon v-else-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.WATER_HEATER" />
    <AirConditionerSmallIcon v-else-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.AC_UNIT_NON_INFRARED" />
    <OtherSmallIcon v-else />
  </div>

  <div v-else-if="props.size === 'large'">
    <HeaterLargeIcon v-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.HEATER" />
    <WaterHeaterLargeIcon v-else-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.WATER_HEATER" />
    <AirConditionerLargeIcon v-else-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.AC_UNIT_NON_INFRARED" />
    <HeatPumpLargeIcon v-else-if="sectionApplianceCategory === PROGRAM_APPLIANCE_CATEGORY.HEAT_PUMP" />
    <OtherLargeIcon v-else />
  </div>
</template>
